<template>
    <div>
        <el-form :inline="true" :model="systemOrderForm" class="forTbFilter" @submit.native.prevent>
            <el-form-item label="是否分销：">
                <el-select>
                    <el-option>全部</el-option>
                    <el-option>已分销</el-option>
                    <el-option>未分销</el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="卡状态：">
                <el-select>
                    <el-option>全部</el-option>
                    <el-option>待激活</el-option>
                    <el-option>正常</el-option>
                    <el-option>断网</el-option>
                    <el-option>停机</el-option>
                    <el-option>异常</el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="卡状态：">
                <el-select>
                    <el-option>全部</el-option>
                    <el-option>包月</el-option>
                    <el-option>包年</el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="开卡公司：">
                <el-select>
                    <el-option>111111</el-option>
                    <el-option>222222</el-option>
                    <el-option>333333</el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="分销商：">
                <el-input v-model="systemOrderForm.agentName"></el-input>
            </el-form-item>
            <el-form-item label="ICCID号：">
                <el-input v-model="systemOrderForm.agentName"></el-input>
            </el-form-item>
            <el-form-item label="接入号：">
                <el-input v-model="systemOrderForm.agentName"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary">搜索查询</el-button>
            </el-form-item>
        </el-form>

        <el-table :data="tableData" border height="628px" @selection-change="handleSelectionChange">
            <el-table-column type="index" label="序号"></el-table-column>
            <el-table-column prop="3" label="ICCID号"></el-table-column>
            <el-table-column prop="3" label="接入号码"></el-table-column>
            <el-table-column prop="3" label="开卡公司"></el-table-column>
            <el-table-column prop="3" label="到期时间"></el-table-column>
            <el-table-column prop="3" label="套餐"></el-table-column>
            <el-table-column prop="3" label="卡片类型"></el-table-column>
            <el-table-column prop="3" label="分销商姓名"></el-table-column>
            <el-table-column prop="5" label="卡状态"></el-table-column>
            <el-table-column prop="6" label="操作">
                <template slot-scope="scope">
                    <el-button type="text" size="small">套餐变更</el-button>
                </template>                  
            </el-table-column>
        </el-table>  
                  
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[100, 200, 300, 400]"
            :page-size="100"
            layout="total, sizes, prev, pager, next, jumper"
            :total="400">
        </el-pagination>        
    </div>
</template>
<script>
export default {
    data(){
        return {
            systemOrderForm: {
                date: '',
                agentName: ''
            },
            tableData: [
                {
                    2: '123123',
                    3: 'aaaaaaa',
                    4: 'ooooooo'
                },
                {
                    2: 'q123123',
                    3: 'qaaaaaaa',
                    4: 'qooooooo'
                }
            ],
            multipleSelection: []
        }
    },
    methods: {
        handleSelectionChange(val){
            this.multipleSelection = val;
        }
    }
}
</script>
<style lang="less" scoped>

</style>

